module.exports = __webpack_public_path__ + "media/images/favicon/favicon-1ebfc0814babba5f41d822b86b58948a.ico";